/* LockToggleComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./LockToggleRenderer');

class LockToggleComponent extends EventEmitter {
  constructor(logger) {
    super();
    this._logger = logger;
    this._renderer = new Renderer(this);
    this._isLocked = true;
    this._registerListeners();
  }
  /*******************************************/
  /* START PRIVATE COMPONENT MODEL METHODS */
  /*******************************************/
  _registerListeners() {}
  _unregisterListeners() {}
  /*******************************************/
  /* END PRIVATE COMPONENT MODEL METHODS */
  /* START PUBLIC COMPONENT MODEL METHODS */
  /*******************************************/
  get renderer() {
    return this.getRenderer();
  }
  getRenderer() {
    return this._renderer;
  }
  get logger() {
    return this._logger;
  }
  shutdown() {
    this._unregisterListeners();
    return this._renderer.shutdown().then(
      () => {
        this._logger = undefined;
        this._isLocked = undefined;
        this._renderer = undefined;
      },
      (err) => {
        this._logger.warn(err, 'LockToggleComponent.shutdown() error');
      }
    );
  }
  get isLocked() {
    return this.getIsLocked();
  }
  set isLocked(val) {
    this.setIsLocked(val);
  }
  getIsLocked() {
    return this._isLocked;
  }
  setIsLocked(val, silent) {
    this._isLocked = val;
    if (!silent) {
      this.emit('UserClick', val);
    }
  }
  /*******************************************/
  /* END COMPONENT MODEL METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE METHODS */
  /* START PUBLIC API METHODS */
  /*******************************************/

  /*******************************************/
  /* END PUBLIC API METHODS */
  /*******************************************/
}
module.exports = LockToggleComponent;
